import refineAttributes from 'javascripts/refineAttributes';
import { Attributes, JobResult } from 'jobs.types';
import { useEffect, useState } from 'react';

const sortByDate = (results: JobResult[]) => {
  if (results === null) return null;
  return results.sort((a, b) =>
    a.lastModificationTimestamp < b.lastModificationTimestamp ? 1 : -1,
  );
};

const useFetchData = (api: string, mocked: boolean) => {
  const [attributes, setAttributes] = useState<Attributes>(null);
  const [jobs, setJobs] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const attributesUrl = mocked ? `${api}/attributes.json` : `${api}/attributes`;
        const attributesResponse = await fetch(attributesUrl);
        const attributesData = await attributesResponse.json();
        const transformedAttributes = refineAttributes(attributesData.attributes);
        setAttributes(transformedAttributes);

        const jobsUrl = mocked ? `${api}/jobs.json` : `${api}/jobs`;
        const jobsResponse = await fetch(jobsUrl);
        const jobsData = await jobsResponse.json();
        const sortedJobs = sortByDate(jobsData.jobs);

        setJobs(sortedJobs);
      } catch (e) {
        setError(e);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  return { attributes, jobs, error, loading };
};

export default useFetchData;
